module.exports = __webpack_public_path__ + "img/20240523_tiankang.e354539a.jpeg";